module.exports = __webpack_public_path__ + "static/img/ic_roadview@2x.329f52b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_roadview@2x.png
// module id = Th4Q
// module chunks = 1